import _ from "lodash";
import React, { useState, useContext } from "react";
import classes from "./CheckListWrapper.scss";
import CheckListContainer from "UIComponents/CheckListContainer";
import { colors } from "Constants";
import { useI18n } from "Hooks";
import { ProjectPlannerContext } from "Projects/modules/ProjectModules";
import { getIsTypeOfProjectPortfolioLOs } from "Projects/modules/Utils";
import { Modal, Button, DSProvider } from "@toddle-edu/ds-web";
import { SHIFT_ENTER_SUBMIT_SHORTCUT } from "Constants/stringConstants";

const styles = {
  checkboxItemStyle: {
    paddingBottom: "12px",
    borderRadius: "4px",
  },
  listItemStyle: {
    flexBasis: "unset",
  },

  listContainerStyle: {
    flexDirection: "column",
    flexWrap: "unset",
    flex: "1",
  },
};

const getOptions = ({ data, currentSelectedFieldData }) => {
  return _.map(
    _.unionBy(
      _.get(data, "resolvedMinimalTree.nodes", []),
      _.get(currentSelectedFieldData, "resolvedMinimalTree.nodes", []),
      "id"
    ),
    item => {
      const { label, type } = item;
      const displayName = _.get(item, ["metadata", "display_name"], null);

      return {
        label:
          getIsTypeOfProjectPortfolioLOs({ type }) &&
          displayName &&
          !_.includes(label, displayName)
            ? `${displayName}: ${label}`
            : label,
        value: item.id,
      };
    }
  );
};

const CheckListWrapper = React.memo(props => {
  const { screenPanelProps, onSubmitClick, elementObj, fieldData } = props;
  const { onCloseClick, currentElementTag, mode } = screenPanelProps;

  const { t } = useI18n(["common", "project"]);
  const { fields } = useContext(ProjectPlannerContext);

  const data = _.find(fields, {
    uid: currentElementTag,
  });

  const [selectedPlannerFieldValue, setSelectedPlannerFieldValue] = useState(
    _.get(fieldData, "value", [])
  );

  const options = getOptions({ data, currentSelectedFieldData: fieldData });

  const updateInputField = params => {
    setSelectedPlannerFieldValue(params);
  };

  const onSaveClick = () => {
    onSubmitClick({
      nodes: _.unionBy(
        _.get(data, "resolvedMinimalTree.nodes", []),
        _.get(fieldData, "resolvedMinimalTree.nodes", []),
        "id"
      ),

      selections: selectedPlannerFieldValue,
      shouldCloseModal: true,
    });
  };
  return (
    <DSProvider dsVersion={"2.0"}>
      <Modal width="480px" height="fit-content" onClose={onCloseClick}>
        <Modal.Header title={t(elementObj.tagLabel)} hasSeparator={true} />
        <Modal.Body isScrollable={true}>
          <div className={classes.checkListContainer}>
            <div>
              <CheckListContainer
                value={selectedPlannerFieldValue}
                options={options}
                updateInputField={updateInputField}
                checkboxItemStyle={styles.checkboxItemStyle}
                listItemStyle={styles.listItemStyle}
                checkListContainerStyle={styles.listContainerStyle}
                fillColor={colors.blue400}
                emptyText={t(elementObj.emptyText)}
                customLabelClass={classes.labelV2}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer hasSeparator={true}>
          <div className={classes.footerContainer}>
            <Button
              variant="neutral"
              size={"medium"}
              onClick={onCloseClick}
              type="outlined"
            >
              {t("common:cancel")}
            </Button>
            <Button
              variant="primary"
              size={"medium"}
              onClick={onSaveClick}
              type="fill"
              disabled={
                _.isEmpty(selectedPlannerFieldValue) && mode === "create"
              }
              shortcut={SHIFT_ENTER_SUBMIT_SHORTCUT}
            >
              {t("common:save")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </DSProvider>
  );
});

CheckListWrapper.displayName = "CheckListWrapper";

export default CheckListWrapper;
